import React, { useEffect, useState } from "react";
import { renderRoutes } from "react-router-config";
import { Redirect } from "react-router-dom";

import { saveAuthToken } from "../apiCommandsExecutor/token";
import useQuery from "../hooks/useQuery";
import { useSession } from "../shared/hooks/useSession";

const HOME_PATH = "/branchesRegister/general";

const SecurityLayout = (props: any) => {
    const { account, loading, refresh } = useSession();
    const { authToken } = useQuery<{ authToken?: string }>();

    // Вход по ссылке: токен из адреса кладём до того, как сессия пойдёт за аккаунтом.
    const [isTokenApplied, setIsTokenApplied] = useState(!authToken);

    useEffect(() => {
        if (!authToken) return;

        saveAuthToken(authToken);
        refresh().then(() => setIsTokenApplied(true));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authToken]);

    if (loading || !isTokenApplied) return null;

    if (!account) {
        return <Redirect to={"/auth/sign-in"} />;
    }

    //@ts-ignore
    const route = props.route || {};

    if (window.location.pathname === "/") {
        return <Redirect to={HOME_PATH} />;
    }

    return renderRoutes(route.routes);
};

export default SecurityLayout;
